import { state } from './State';
import { actions } from './Actions';
import { getters } from './Getters';
import { defineStore } from 'pinia';

export const useCartStore = defineStore('cart', {
  state,
  getters,
  actions,
});
